import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function ProtectedRoute({ children, requireAuth = true, redirectTo = '/signin' }) {
  const { t } = useTranslation();
  const location = useLocation();
  const { isAuthenticated, authLoading } = useAuth();

  // Show loading while checking auth
  if (authLoading) {
    return (
      <div className="min-h-dvh flex items-center justify-center">
        <div className="text-center">
          <div className="text-lg text-content-secondary">{t('protectedRoute.loading')}</div>
        </div>
      </div>
    );
  }

  if (requireAuth && !isAuthenticated) {
    // Redirect to sign-in page with return url
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  if (!requireAuth && isAuthenticated) {
    // Redirect away from auth pages if already signed in
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;